import { useParams } from 'react-router-dom';
import HostSessionProvider from '@/providers/HostSessionControlProvider';

interface HostSessionWrapperProps {
  children: React.ReactNode;
}

export default function HostSessionWrapper({ children }: HostSessionWrapperProps) {
  const { id } = useParams();

  if (!id) {
    return <div>Loading...</div>;
  }

  return <HostSessionProvider sessionID={id}>{children}</HostSessionProvider>;
}
